import { IconType } from '@csp-misc/web-ui-icons';
import { WebHcpNavigationTabsTabsBlock } from '@csp/csp-web-content-definitions';
import { NavTab } from '@csp/csp-web-ui';
import { FC } from 'react';
import { CspPath } from '../../../CspPath';
import { useInformedConsentIsEnabled } from '../../informed-consent/hook/useInformedConsentIsEnabled';
import { useCanViewPatientsTab } from '../../patient/hooks/useCanViewPatientsTab';
import { useCanViewReports } from '../../reports/hook/useCanViewReports';
import { HeaderNavTabsComponent } from '../component/HeaderNavTabsComponent';
import { useCanViewSites } from '../hooks/useCanViewSites';
import { useSelectedNavTab } from '../hooks/useSelectedNavTab';

type Props = {
  tabs: WebHcpNavigationTabsTabsBlock;
};

export const MainNavTabsContainer: FC<Props> = ({ tabs }) => {
  const informedConsentIsEnabled = useInformedConsentIsEnabled();
  const canViewReports = useCanViewReports();
  const canViewPatientsTab = useCanViewPatientsTab();
  const canViewSites = useCanViewSites();

  const mainNavTabs: NavTab<CspPath>[] = [
    {
      icon: 'studyProgress',
      label: tabs.button.overview.label,
      path: CspPath.STUDY_OVERVIEW,
      isEnabledFeature: true,
    },
    {
      icon: 'patients',
      label: tabs.button.patients.label,
      path: CspPath.PATIENT_LIST,
      isEnabledFeature: canViewPatientsTab,
    },
    {
      icon: 'team',
      label: tabs.button.teams.label,
      path: CspPath.TEAM_MEMBER_LIST,
      isEnabledFeature: true,
    },
    {
      icon: 'site',
      label: tabs.button.sites.label,
      path: CspPath.SITE_LIST,
      isEnabledFeature: canViewSites,
    },
    {
      icon: 'studyStatus',
      label: tabs.button.reports.label,
      path: CspPath.REPORTS,
      isEnabledFeature: canViewReports,
    },
    {
      icon: 'contract',
      label: 'Informed consent',
      path: CspPath.INFORMED_CONSENT,
      isEnabledFeature: informedConsentIsEnabled,
    },
  ]
    .filter(i => i.isEnabledFeature)
    .map(({ icon, ...tab }) => ({
      ...tab,
      icon: icon as IconType,
    }));

  const selectedTab = useSelectedNavTab(mainNavTabs, CspPath.STUDY_OVERVIEW);
  return <HeaderNavTabsComponent tabs={mainNavTabs} selectedPath={selectedTab} />;
};
